//import { mifuncion } from "./modules/test";
import { menu } from "./modules/menu";
import { modal } from "./modules/modal";
import { form } from "./modules/form";
import { modalInstructions } from "./modules/home";
import { swiper } from "./modules/swiper";
import {redirectRegion} from './modules/regionSlider'
import "../sass/main.scss";
import { moreInfo } from "./modules/moreInfo";
import { loadToggleHandlers } from './modules/Toggle';
import { loadSearchHandler } from './modules/Search';
/*import { comeBack } from "./modules/comeBack";*/

window.addEventListener('load', ()=>{
    //mifuncion();
    menu();
    modal();
    modalInstructions();
    form();
    swiper();
    redirectRegion();
    moreInfo();
    loadToggleHandlers();
    loadSearchHandler();
    /*comeBack();*/
    document.addEventListener("contextmenu", function(e){
        e.preventDefault();
    }, false);
});